import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import {
  activeLittersV1QueryDefinition,
  buyerAssignedLitterV1QueryDefinition
} from '../utils/queryDefinitions';

export default function useAssignableLitterData(buyerProfileId: number) {
  const buyerAssignedLitterData = useResourceQuery(
    buyerAssignedLitterV1QueryDefinition({ id: buyerProfileId })
  );

  const assignedLitter = buyerAssignedLitterData?.value;
  const assignedDog = (assignedLitter as any)?.puppy || {};

  const activeLittersData = useResourceQuery(activeLittersV1QueryDefinition());

  const litters = activeLittersData?.value;

  const allPuppies = (litters as any[]).reduce((acc: any[], litter: any) => {
    return acc.concat(litter?.puppies || []);
  }, []);

  function findLitterById(litterId: number) {
    return (litters as any[]).find((litter: any) => litter.id === litterId);
  }

  function findPuppyById(puppyId: number) {
    return allPuppies.find((puppy: any) => puppy.id === puppyId);
  }

  const isLoadingData =
    buyerAssignedLitterData.isFetching && activeLittersData?.isFetching;

  return {
    buyerAssignedLitterData,
    activeLittersData,
    isLoadingData,
    assignedLitter,
    assignedDog,
    litters,
    allPuppies,
    findLitterById,
    findPuppyById
  };
}
